import service from "../../api/FetchInterceptor";
import {useEffect, useState} from "react";
import {Descriptions, Drawer} from "antd";
import dayjs from "dayjs";
import ListFile from "../../components/fileList";

const ShowPublication = ({ id, open, setOpen }) => {
    const [publication, setPublication] = useState()

    const loadPublication = () => {
        service({
            method: 'GET',
            url: `/publications/${id}`,
        }).then((response) => {
            setPublication(response)
        })
    }

    useEffect(() => {
        if (open) loadPublication()
    }, [open]);

    const onPreview = (file) => {
        window.open(file.path, "_blank");
    };

    return (
        <Drawer
            title="Détails de la publication"
            open={open}
            onClose={() => setOpen(false)}
            width={700}
        >
            {publication && (
                <>
                    <Descriptions layout="vertical">
                        <Descriptions.Item label="Type de publication" span={3}>{publication.type.label}</Descriptions.Item>
                        <Descriptions.Item label="Titre" span={3}>{publication.title}</Descriptions.Item>
                        <Descriptions.Item label="Slug" span={3}>{publication.slug}</Descriptions.Item>
                        <Descriptions.Item label="Description" span={3}><p dangerouslySetInnerHTML={{ __html : publication.body}} /></Descriptions.Item>
                        <Descriptions.Item label="Date de création" span={3}>{dayjs(publication.created_at).format('DD/MM/YYYY à HH:mm:ss')}</Descriptions.Item>
                    </Descriptions>

                    <ListFile attachments={publication.attachments} onPreview={onPreview} />
                </>
            )}
        </Drawer>
    )
}

export default ShowPublication